export const USERFEEDBACKACTIONS = {
    SET_FIELD: 'set_field',
    ADD_TO_LOADING_LAWYERS_LIST: 'add_to_loading_lawyers_list',
    REMOVE_FROM_LOADING_LAWYERS_LIST: 'remove_from_loading_lawyers_list',
    INCREMENT_CURRENT_LAWYER_COMPLETIONS: 'INCREMENT_CURRENT_LAWYER_COMPLETIONS',

};

export const initialUserFeedbackState = {
    generating: false,
    loadingScope: false,
    loadingAssumptions: false,
    loadingLawyers: false,
    loadingLawyerList: [] as string[], // List of lawyer names whose bios are currently being loaded
    loadingExperiences: false,
    documentLoading: false,
    isModalOpen: false,
    lawyerLoadingState: null as string | null,
    experienceLoadingState: null as string | null,
    saveLoading: false,
    currentLawyerCompletions: 0,

};

// Reducer function to handle all state updates
export function userFeedbackReducer(state: typeof initialUserFeedbackState, action: { type: string, field: string, value: any }): typeof initialUserFeedbackState {
    switch (action.type) {
        case USERFEEDBACKACTIONS.SET_FIELD:
            return { ...state, [action.field]: action.value };
        case USERFEEDBACKACTIONS.ADD_TO_LOADING_LAWYERS_LIST:
            return { ...state, loadingLawyerList: [...state.loadingLawyerList, action.value] };
        case USERFEEDBACKACTIONS.REMOVE_FROM_LOADING_LAWYERS_LIST:
            return { ...state, loadingLawyerList: state.loadingLawyerList.filter((lawyer) => lawyer !== action.value) };
        case USERFEEDBACKACTIONS.INCREMENT_CURRENT_LAWYER_COMPLETIONS:
            return {
                ...state,
                currentLawyerCompletions: state.currentLawyerCompletions + 1,
            };
        default:
            return state;
    }




}
